module.exports = "/img/_/_/_/assets/images//logo.png?a421bbce6339f8e70205218d848e99b7";